import React from "react";
import Joi from "joi-browser";
import Form from "./common/form";
import { getDream, saveDream } from "../services/dreamService";
import { getGenres } from "../services/genreService";

class DreamForm extends Form {
  state = {
    data: {
      title: "",
      genreId: "",
      numberInStock: "",
      dailyRentalRate: ""
    },
    genres: [],
    errors: {}
  };

  schema = {
    _id: Joi.string(),
    title: Joi.string()
      .required()
      .label("Title"),
    genreId: Joi.string()
      .required()
      .label("Genre"),
    numberInStock: Joi.number()
      .required()
      .min(0)
      .max(100)
      .label("Number in Stock"),
    dailyRentalRate: Joi.number()
      .required()
      .min(0)
      .max(10)
      .label("Daily Rental Rate")
  };

  async populateGenres() {
    const { data: genres } = await getGenres();
    this.setState({ genres });
  }

  async populateDream() {
    try {
      const dreamId = this.props.match.params.id;
      if (dreamId === "new") return;

      const { data: dream } = await getDream(dreamId);
      this.setState({ data: this.mapToViewModel(dream) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateGenres();
    await this.populateDream();
  }

  mapToViewModel(dream) {
    return {
      _id: dream._id,
      title: dream.title,
      genreId: dream.genre._id,
      numberInStock: dream.numberInStock,
      dailyRentalRate: dream.dailyRentalRate
    };
  }

  doSubmit = async () => {
    await saveDream(this.state.data);

    this.props.history.push("/ddreams");
  };

  render() {
    return (
      <div>
 <div className="row">
        <div className="col-sm-1">
        {this.renderIconButtonButton("fa fa-trash")}

 </div>
 <div className="col-sm-1">
        {this.renderIconButtonButton("fa fa-trash")}

 </div>

</div>

        <h1>Dream Form</h1>
        <form onSubmit={this.handleSubmit}>
          {this.renderInput("title", "Title")}
          {this.renderSelect("genreId", "Genre", this.state.genres)}
          {this.renderInput("numberInStock", "Number in Stock", "number")}
          {this.renderInput("dailyRentalRate", "Rate")}
          {this.renderButton("Save")}
        </form>
      </div>
    );
  }
}

export default DreamForm;



// WEBPACK FOOTER //
// ./src/components/dreamForm.jsx